import { RouterProvider, createHashRouter } from 'react-router-dom';
import './App.css';
import { Toaster } from 'react-hot-toast';
import { ToastContainer } from 'react-toastify';
import { useContext, useEffect } from 'react';
import { UserContext } from './Context/UserContext.js';
import { jwtDecode } from 'jwt-decode';


import Layout from './Components/Layout/Layout.jsx';
import Home from './Components/Home/Home.jsx';
import Login from './Components/Login/Login.jsx';
import Register from './Components/Register/Register.jsx';
import NotFound from './Components/NotFound/NotFound.jsx';
import ProtectedRoute from './MiddleWare/ProtectedRoute/ProtectedRoute.jsx';
import Cart from './Components/Cart/Cart.jsx';
import Price from './Components/Price/Price.jsx';
import AddTest from './Components/AddTest/AddTest.jsx';
import Order from './Components/Order/Order.jsx';
import OrderOldPatient from './Components/OrderOldPatient/OrderOldPatient.jsx';
import AllOrderLoggedUser from './Components/AllOrderLoggedUser/AllOrderLoggedUser.jsx';
import Contact from './Components/Contact/Contact.jsx';
import DashBoard from './Components/DashBoard/DashBoard/DashBoard.jsx';
import HomeDashboard from './Components/DashBoard/HomeDashboard/HomeDashboard.jsx';
import SpecificOrder from './Components/DashBoard/SpecificOrder/SpecificOrder.jsx';
import UserDashboard from './Components/DashBoard/UserDashboard/UserDashboard.jsx';
import SpecificUser from './Components/DashBoard/SpecificUser/SpecificUser.jsx';
import CompanyDashboard from './Components/DashBoard/CompanyDashboard/CompanyDashboard.jsx';
import SpecificCompany from './Components/DashBoard/SpecificCompany/SpecificCompany.jsx';
import AddCompany from './Components/DashBoard/AddCompany/AddCompany.jsx';
import UpdateCompany from './Components/DashBoard/UpdateCompany/UpdateCompany.jsx';
import ChangeImageCompany from './Components/DashBoard/ChangeImageCompany/ChangeImageCompany.jsx';
import TestDashboard from './Components/DashBoard/TestDashboard/TestDashboard.jsx';
import SpecificTest from './Components/DashBoard/SpecificTest/SpecificTest.jsx';
import UpdatePrice from './Components/DashBoard/UpdatePrice/UpdatePrice.jsx';
import UpdateTest from './Components/DashBoard/UpdateTest/UpdateTest.jsx';
import AddTestAdmin from './Components/DashBoard/AddTestAdmin/AddTestAdmin.jsx';
import PatientDashboard from './Components/DashBoard/PatientDashboard/PatientDashboard.jsx';
import SpecificPatient from './Components/DashBoard/SpecificPatient/SpecificPatient.jsx';
import AnalysisProfile from './Components/AnalysisProfile/AnalysisProfile.jsx';
import RadiologyProfile from './Components/RadiologyProfile/RadiologyProfile.jsx';
import MonthProfile from './Components/MonthProfile/MonthProfile.jsx';
import ReportDashboard from './Components/DashBoard/ReportDashboard/ReportDashboard.jsx';
import UserProfile from './Components/UserProfile/UserProfile.jsx';
import AddNewPrice from './Components/DashBoard/AddNewPrice/AddNewPrice.jsx';
import LoginOnlineSystem from './Components/OnlineSystem/LoginOnlineSystem/LoginOnlineSystem.jsx';
import LayoutOnlineSystem from './Components/OnlineSystem/LayoutOnlineSystem/LayoutOnlineSystem.jsx';
import TransformationOnline from './Components/OnlineSystem/TransformationOnline/TransformationOnline.jsx';
import ApprovedSearch from './Components/OnlineSystem/ApprovedSearch/ApprovedSearch.jsx';
import ShareWebsite from './Components/ShareWebsite/ShareWebsite.jsx';
import PriceOffers from './Components/PriceOffers/PriceOffers.jsx';
import ProtectedOnline from './MiddleWare/ProtectedOnline/ProtectedOnline.jsx';
import Teeth from './Components/Teeth/Teeth.jsx';
import Cosmetology from './Components/Cosmetology/Cosmetology.jsx';
import Endoscopes from './Components/Endoscopes/Endoscopes.jsx';
import Eyes from './Components/Eyes/Eyes.jsx';
import Pharmacy from './Components/Pharmacy/Pharmacy.jsx';
import Nursing from './Components/Nursing/Nursing.jsx';
import Hospital from './Components/Hospital/Hospital.jsx';
import PhysicalTherapy from './Components/PhysicalTherapy/PhysicalTherapy.jsx';
import MorePage from './Components/MorePage/MorePage.jsx';
import UpdateUserProfile from './Components/UpdateUserProfile/UpdateUserProfile.jsx';
import ChangeUserImage from './Components/ChangeUserImage/ChangeUserImage.jsx';
import SickHistory from './Components/SickHistory/SickHistory.jsx';
import ChangePassword from './Components/ChangePassword/ChangePassword.jsx';
import ForgetPassword from './Components/ForgetPassword/ForgetPassword.jsx';
import isTokenValid from './Utilities/checkToken.js';
import HomeOnline from './Components/OnlineSystem/HomeOnline/HomeOnline.jsx';
import GuestRoute from './MiddleWare/GuestRoute/GuestRoute.jsx';
import Prescription from './Components/Prescription/Prescription.jsx';
import SendPrescription from './Components/SendPrescription/SendPrescription.jsx';
import BranchDashboard from './Components/DashBoard/BranchDashboard/BranchDashboard.jsx';
import SpecificBranch from './Components/DashBoard/SpecificBranch/SpecificBranch.jsx';
import OrderDashboard from './Components/DashBoard/OrderDashboard/OrderDashboard.jsx';
import CompleteProfile from './Components/CompleteProfile/CompleteProfile.jsx';
import LoginSuccessGoogle from './Components/LoginSuccessGoogle/LoginSuccess.jsx';
import PrescriptionDashboard from './Components/DashBoard/PrescriptionDashboard/PrescriptionDashboard.jsx';
import Setting from './Components/DashBoard/Setting/Setting.jsx';
import AddOrderOnlineAdmin from './Components/DashBoard/AddOrderOnlineAdmin/AddOrderOnlineAdmin.jsx';
import ProfileDashboard from './Components/DashBoard/ProfileDashboard/ProfileDashboard.jsx';
import SpecificProfile from './Components/DashBoard/SpecificProfile/SpecificProfile.jsx';
import ShowAnalysisProfile from './Components/ShowAnalysisProfile/ShowAnalysisProfile.jsx';
import PrivacyPolicy from './Components/PrivacyPolicy/PrivacyPolicy.jsx';
import Checkout from './Components/Checkout/Checkout.jsx';
import Instapay from './Components/Instapay/Instapay.jsx';
import PaidCashOrder from './Components/DashBoard/PaidCashOrder/PaidCashOrder.jsx';
import WalletPayment from './Components/PaymentMethod/WalletPaymentPage/walletPayment.jsx';
import FawryPayment from './Components/PaymentMethod/FawryPaymentPage/fawryPayment.jsx';
import LandingPage from './Components/Landingpage/landingpage.jsx';
import { AboutUsSection } from './Components/AboutUs/aboutUs.jsx';
// const socket = io(process.env.REACT_APP_BASE_URL) ;



let routers = createHashRouter([
	// let routers = createBrowserRouter([
	{
		path: "/", element: <Layout />, children: [
			{ index: true, element: <GuestRoute><LandingPage /></GuestRoute> },
			{ path: "login", element: <GuestRoute><Login /></GuestRoute> },
			{ path: "register", element: <GuestRoute><Register /></GuestRoute> },
			{ path: "contact", element: <Contact /> },
			{ path: "shareWebsite", element: <ShareWebsite /> },
			{ path: "home", element: <ProtectedRoute><Home /> </ProtectedRoute> },
			{ path: "userProfile", element: <ProtectedRoute><UserProfile /></ProtectedRoute> },
			{ path: "cart", element: <ProtectedRoute><Cart /></ProtectedRoute> },
			{ path: "price", element: <ProtectedRoute><Price /></ProtectedRoute> },
			{ path: "addTest/:id", element: <ProtectedRoute><AddTest /></ProtectedRoute> },
			{ path: "allOrderLoggedUser", element: <ProtectedRoute><AllOrderLoggedUser /></ProtectedRoute> },
			{ path: "analysisProfile", element: <ProtectedRoute><AnalysisProfile /></ProtectedRoute> },
			{ path: "radiologyProfile", element: <ProtectedRoute><RadiologyProfile /></ProtectedRoute> },
			{ path: "monthProfile", element: <ProtectedRoute><MonthProfile /></ProtectedRoute> },
			{ path: "offers", element: <ProtectedRoute><PriceOffers /> </ProtectedRoute> },
			{ path: "teeth", element: <ProtectedRoute><Teeth /></ProtectedRoute> },
			{ path: "cosmetology", element: <ProtectedRoute><Cosmetology /></ProtectedRoute> },
			{ path: "endoscopes", element: <ProtectedRoute><Endoscopes /></ProtectedRoute> },
			{ path: "eyes", element: <ProtectedRoute><Eyes /></ProtectedRoute> },
			{ path: "pharmacy", element: <ProtectedRoute><Pharmacy /></ProtectedRoute> },
			{ path: "nursing", element: <ProtectedRoute><Nursing /></ProtectedRoute> },
			{ path: "hospital", element: <ProtectedRoute><Hospital /></ProtectedRoute> },
			{ path: "physicalTherapy", element: <ProtectedRoute><PhysicalTherapy /></ProtectedRoute> },
			{ path: "about", element: <AboutUsSection /> },
			{ path: "MorePage", element: <ProtectedRoute><MorePage /></ProtectedRoute> },
			{ path: "UpdateUserProfile", element: <ProtectedRoute><UpdateUserProfile /></ProtectedRoute> },
			{ path: "ChangeUserImage", element: <ProtectedRoute><ChangeUserImage /></ProtectedRoute> },
			{ path: "SickHistory", element: <ProtectedRoute><SickHistory /></ProtectedRoute> },
			{ path: "Prescription", element: <ProtectedRoute><Prescription /></ProtectedRoute> },
			{ path: "SendPrescription", element: <ProtectedRoute><SendPrescription /></ProtectedRoute> },
			{ path: "ChangePassword", element: <ProtectedRoute><ChangePassword /></ProtectedRoute> },
			{ path: "ForgetPassword", element: <ForgetPassword /> },
			{ path: "LoginSuccessGoogle", element: <LoginSuccessGoogle /> },
			{ path: "CompleteProfile", element: <ProtectedRoute><CompleteProfile /></ProtectedRoute> },
			{ path: "OrderOldPatient", element: <ProtectedRoute><OrderOldPatient /></ProtectedRoute> },
			{ path: "order", element: <ProtectedRoute><Order /></ProtectedRoute> },
			{ path: "PrivacyPolicy", element: <PrivacyPolicy /> },
			{ path: "ShowAnalysisProfile/:id", element: <ProtectedRoute><ShowAnalysisProfile /></ProtectedRoute> },
			{ path: "Checkout", element: <ProtectedRoute><Checkout /></ProtectedRoute> },
			{ path: "wallet-payment", element: <ProtectedRoute><WalletPayment /></ProtectedRoute> },
			{ path: "fawry-payment", element: <ProtectedRoute><FawryPayment /></ProtectedRoute> },
			{ path: "Instapay", element: <ProtectedRoute><Instapay /></ProtectedRoute> },


			{
				path: "dashBoard/", element: <ProtectedRoute allowedRoles={["admin", "moderator"]}><DashBoard /></ProtectedRoute>, children: [
					{ index: true, element: <ProtectedRoute><HomeDashboard /></ProtectedRoute> },
					{ path: "specificOrder/:id", element: <ProtectedRoute><SpecificOrder /></ProtectedRoute> },
					{ path: "OrderDashboard", element: <ProtectedRoute><OrderDashboard /></ProtectedRoute> },
					{ path: "companyDashboard", element: <ProtectedRoute><CompanyDashboard /></ProtectedRoute> },
					{ path: "specificCompany/:id", element: <ProtectedRoute><SpecificCompany /></ProtectedRoute> },
					{ path: "userDashboard", element: <ProtectedRoute><UserDashboard /></ProtectedRoute> },
					{ path: "specificUser/:id", element: <ProtectedRoute><SpecificUser /></ProtectedRoute> },
					{ path: "addCompany", element: <ProtectedRoute><AddCompany /></ProtectedRoute> },
					{ path: "updateCompany/:id", element: <ProtectedRoute><UpdateCompany /></ProtectedRoute> },
					{ path: "changeImageCompany", element: <ProtectedRoute><ChangeImageCompany /></ProtectedRoute> },
					{ path: "testDashboard", element: <ProtectedRoute><TestDashboard /></ProtectedRoute> },
					{ path: "specificTest/:id", element: <ProtectedRoute><SpecificTest /></ProtectedRoute> },
					{ path: "updateTest/:id", element: <ProtectedRoute><UpdateTest /></ProtectedRoute> },
					{ path: "updatePrice/:testId/:priceId", element: <ProtectedRoute><UpdatePrice /></ProtectedRoute> },
					{ path: "addTestAdmin", element: <ProtectedRoute><AddTestAdmin /></ProtectedRoute> },
					{ path: "patientDashboard", element: <ProtectedRoute><PatientDashboard /></ProtectedRoute> },
					{ path: "specificPatient/:id", element: <ProtectedRoute><SpecificPatient /></ProtectedRoute> },
					{ path: "reportDashboard", element: <ProtectedRoute><ReportDashboard /></ProtectedRoute> },
					{ path: "addNewPrice/:testId", element: <ProtectedRoute><AddNewPrice /></ProtectedRoute> },
					{ path: "BranchDashboard", element: <ProtectedRoute><BranchDashboard /></ProtectedRoute> },
					{ path: "SpecificBranch/:id", element: <ProtectedRoute><SpecificBranch /></ProtectedRoute> },
					{ path: "PrescriptionDashboard", element: <ProtectedRoute><PrescriptionDashboard /></ProtectedRoute> },
					{ path: "Setting", element: <ProtectedRoute><Setting /></ProtectedRoute> },
					{ path: "AddOrderOnlineAdmin", element: <ProtectedRoute><AddOrderOnlineAdmin /></ProtectedRoute> },
					{ path: "ProfileDashboard", element: <ProtectedRoute><ProfileDashboard /></ProtectedRoute> },
					{ path: "specificProfile/:id", element: <ProtectedRoute><SpecificProfile /></ProtectedRoute> },
					{ path: "PaidCashOrder", element: <ProtectedRoute><PaidCashOrder /></ProtectedRoute> },
				]
			},
			{ path: "*", element: <NotFound /> },
		]
	},

	{
		path: "onlineSystem/", element: <LayoutOnlineSystem />, children: [
			{ index: true, element: <HomeOnline /> },
			{ path: "login", element: <LoginOnlineSystem /> },
			{ path: "transportation", element: <ProtectedOnline><TransformationOnline /></ProtectedOnline> },
			{ path: "approvedSearch", element: <ProtectedOnline><ApprovedSearch /></ProtectedOnline> },
			{ path: "*", element: <NotFound /> },
		]
	},

])








function App() {

	const {
		setRole,
		setUserToken,
		setLoggedUser,
		setModerator,
		setAdmin,
		setCompleteInfoUser
	} = useContext(UserContext);



	useEffect(() => {
		//& Get Token in Local Storage And Save in Use State :
		const token = localStorage.getItem("token")
		if (token && isTokenValid(token)) {
			setUserToken(token);
			try {
				const decoded = jwtDecode(token);

				//& Set User Role :
				setLoggedUser(decoded);


				//& Set User Role :
				setRole(decoded.role);

				//& Check Admin Or Moderator Or User :
				if (decoded.role === "admin") {
					setAdmin(true);
				} else if (decoded.role === "moderator") {
					setModerator(true);
				}


				//& Check User Information Completed :
				if (decoded.phone === undefined || decoded.birthDay === undefined) {
					setCompleteInfoUser(false);
				}
			}
			catch (err) {
				console.error("Error decoding token", err);
				localStorage.removeItem("token");
				setUserToken(null);
			}
		} else {
			localStorage.removeItem("token");
		}



		// //& Get Logged User From Local Storage:
		// const user = JSON.parse(localStorage.getItem("user"));
		// if (user) {
		// 	setLoggedUser(user);
		// } else {
		// 	setLoggedUser(null); // Handle case where user is missing
		// }
	}, [setRole, setUserToken, setLoggedUser, setModerator, setAdmin, setCompleteInfoUser])



	return (
		<>
			<RouterProvider router={routers} />
			<Toaster />
			<ToastContainer />
		</>
	);
}

export default App;
